import { map, get } from 'lodash';
import React from 'react';

import Button, { TYPES } from 'components/Button';
import { SHOP_IDS } from 'constants/shops';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';
import Settings from 'utils/Settings';

const BUTTONS = {
  MENS: {
    label: 'cart.shopMens',
    url: '/collections/mens',
  },
  WOMENS: {
    label: 'cart.shopWomens',
    url: '/collections/womens',
  },
  KIDS: {
    label: 'cart.shopKids',
    url: '/products/smallbirds-wool-runners',
  },
  SOCKS: {
    label: 'cart.shopSocks',
    url: '/collections/trino-socks',
  },
  MENS_SALE: {
    label: 'cart.shopMensSale',
    url: '/collections/sale-mens-shoes',
  },
  WOMENS_SALE: {
    label: 'cart.shopWomensSale',
    url: '/collections/sale-womens-shoes',
  },
};

const SHOP_BUTTONS = {
  [SHOP_IDS.US]: [
    BUTTONS.MENS,
    BUTTONS.WOMENS,
    BUTTONS.SOCKS,
    BUTTONS.MENS_SALE,
    BUTTONS.WOMENS_SALE,
  ],
  [SHOP_IDS.UK]: [
    BUTTONS.MENS,
    BUTTONS.WOMENS,
    BUTTONS.SOCKS,
    BUTTONS.MENS_SALE,
    BUTTONS.WOMENS_SALE,
  ],
  [SHOP_IDS.EU]: [
    BUTTONS.MENS,
    BUTTONS.WOMENS,
    BUTTONS.SOCKS,
    BUTTONS.MENS_SALE,
    BUTTONS.WOMENS_SALE,
  ],
};

const CartEmptyState = () => {
  const buttons = get(SHOP_BUTTONS, [Settings.shopID]);

  return (
    <div className="CartEmptyState">
      <p className="CartEmptyState__heading">{I18n.localize('cart.empty')}</p>
      <div className="CartEmptyState__buttons">
        {map(buttons, ({ label, url }, index) => (
          <Button
            type={TYPES.OUTLINE}
            linkTo={url}
            isFullWidth
            key={index}
            className="CartEmptyState__button"
          >
            {I18n.localize(label)}
          </Button>
        ))}
      </div>
      <style jsx>
        {`
          .CartEmptyState {
            height: 100%;
            padding: ${Theme.get('spacing') * 4}px;
          }

          .CartEmptyState__heading {
            text-align: center;
            margin: 0 0 ${Theme.get('spacing') * 4}px;
          }

          .CartEmptyState__heading {
            color: ${Theme.get('colors-black')};
            letter-spacing: ${Theme.get('letter-spacing-px')};
            font-weight: ${Theme.get('font-weight-semi-bold')};
          }

          .CartEmptyState__buttons {
            width: 60%;
            margin: 0 auto;
          }
        `}
      </style>
      <style jsx global>
        {`
          .CartEmptyState .Button {
            margin-bottom: ${Theme.get('spacing') * 2}px;
            text-transform: uppercase;
          }
        `}
      </style>
    </div>
  );
};

CartEmptyState.propTypes = {};

export default CartEmptyState;
